module.exports = __webpack_public_path__ + "img/product_49.7987ba4.webp";